import * as React from "react";
import styled from "@emotion/styled";
//import { css } from "@emotion/core";
import Question from "../components/textquestion";
import databig from '../../databig.json'


const Card = styled.div`
    margin: 16px 24px 48px 24px;
    padding: 24px;
    width: calc(100vw - 48px);
    background: #FFFFFF;
    ${'' /* box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.08), 0px 0px 16px rgba(0, 0, 0, 0.08); */}
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.04);
    border-radius: 8px;
`


export default props => {
  return (
    <div>
      {databig.big.filter((cell)=>{return cell.type === props.questionType}).map((cell, index)=> (
        <Card key={index}>
            <Question 
              author={cell.author} 
              question={cell.question}
              count={cell.count}>
            </Question>
        </Card>
      ))}
    </div>
  );
};

